// extracted by mini-css-extract-plugin
export var banners = "Notifications-module--banners--78234";
export var button = "Notifications-module--button--e2477";
export var closeIcon = "Notifications-module--close-icon--f6c3e";
export var content = "Notifications-module--content--44407";
export var icon = "Notifications-module--icon--15974";
export var notification = "Notifications-module--notification--edb9c";
export var toasts = "Notifications-module--toasts--7b85a";